export const BOOKING_TYPES = [
  { id: "home", name: "Home Visit", duration: 60, durationLabel: "60 minutes", price: "R1,050" },
  { id: "complex", name: "Complex Physiotherapy Assessment & Treatment", duration: 75, durationLabel: "1 hour 15 minutes", price: "R950" },
  { id: "chest", name: "Chest Physiotherapy, Adults & Paediatrics", duration: 60, durationLabel: "1 hour", price: "R900" },
  { id: "initial", name: "Initial Assessment & Treatment", duration: 60, durationLabel: "1 hour", price: "R900" },
  { id: "followup", name: "Follow Up Treatment", duration: 30, durationLabel: "30 minutes", price: "R600" },
];

export const CASH_PRICE_NOTE =
  "Prices shown are cash prices only. Medical aid patients are charged at their medical aid scheme rate.";
